module.exports = __webpack_public_path__ + "img/anli_ziti.3d88752a.png";